"use client";

import { useEffect, useRef, useState, useCallback } from "react";

const NEXT_PUBLIC_TURNSTILE_SITE_KEY = "0x4AAAAAAB6d8Wnb1P8LEJdK";

interface TurnstileCaptchaProps {
  onVerify: (token: string | null) => void;
}

const TurnstileCaptcha: React.FC<TurnstileCaptchaProps> = ({ onVerify }) => {
  const captchaRef = useRef<HTMLDivElement>(null);
  const [rendered, setRendered] = useState(false);

  const renderCaptcha = useCallback(() => {
    if (!captchaRef.current || rendered) return;

    window.turnstile?.render(captchaRef.current, {
      sitekey: NEXT_PUBLIC_TURNSTILE_SITE_KEY,
      theme: "light",
      size: "normal",
      callback: (token: string) => onVerify(token),
      "error-callback": () => onVerify(null),
      // "expired-callback": () => onVerify(null),
      "expired-callback": () => {
        console.warn("Turnstile token expired, resetting...");
        onVerify(null);
        setRendered(false); // trigger re-render
        setTimeout(renderCaptcha, 100); // re-render captcha box
      }
    });

    setRendered(true);
  }, [onVerify, rendered]);

  useEffect(() => {
    if (!window.turnstile) {
      const script = document.createElement("script");
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
      script.onload = renderCaptcha;
    } else {
      renderCaptcha();
    }
  }, [renderCaptcha]);

  return <div ref={captchaRef} className="turnstile-container" />;
};

export default TurnstileCaptcha;